import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../components/loader/loader";
import Layout from "../layout";
import Users from "../pages/userManagement/users";
import Services from "../pages/serviceManagement/services";
import AddNewServices from "../pages/serviceManagement/addNewServices";

import IndustryList from "../pages/industry/IndustryList";
import AddIndustry from "../pages/industry/AddIndustry";
import EditIndustry from "../pages/industry/EditIndustry";
import EditService from "../pages/serviceManagement/EditService";
import EditVendor from "../pages/vendor/EditVendor";
import Login from "../pages/login/login";
import Dashboard from "../pages/dashboard/dashboard";
import AddVendorService from "../pages/vendorService/AddVendorService";
import VendorServiceList from "../pages/vendorService/VendorServiceList";
import EditVendorService from "../pages/vendorService/EditVendorSerice";
import Profile from "../pages/profile/profile";
import CountryControl from "../pages/countryControl/countryControl";
import ForgotPassword from "../pages/login/forgotPassowrd";
import NewPassword from "../pages/login/newPassword";
import OrderList from "../pages/orderManagement/orderList";
import OrderDetail from "../pages/orderManagement/orderDetail";
import Chatconfiguration from "../pages/chatConfiguration/chatconfiguration";
import Setting from "../pages/setting/setting";
import OrderAnalysis from "../pages/orderManagement/orderAanalysis";
import VegetationType from "../pages/vegetationType/vegetationType";

// Lazy-loaded pages
// const Login = lazy(() => import('../pages/login/login'));
const VendorDetails = lazy(() => import("../pages/vendor/vendordetails"));
const AddNewVendor = lazy(() => import("../pages/vendor/addNewVendor"));

const Approutes = () => {
  const routeList = [
    { path: "/", element: <Login />, layout: false },
    { path: "/dashboard", element: <Dashboard />, layout: true },
    { path: "/vendors", element: <VendorDetails />, layout: true },
    { path: "/add-vendor", element: <AddNewVendor />, layout: true },
    { path: "/edit-vendor", element: <EditVendor />, layout: true },
    { path: "/users", element: <Users />, layout: true },
    { path: "/services", element: <Services />, layout: true },
    { path: "/add-services", element: <AddNewServices />, layout: true },
    { path: "/edit-services", element: <EditService />, layout: true },
    { path: "/industry", element: <IndustryList />, layout: true },
    { path: "/add-industry", element: <AddIndustry />, layout: true },
    { path: "/edit-industry", element: <EditIndustry />, layout: true },
    { path: "/vendor-services", element: <VendorServiceList />, layout: true },
    { path: "/add-vendor-service", element: <AddVendorService />, layout: true },
    { path: "/edit-vendor-service", element: <EditVendorService />, layout: true },
    { path: "/profile", element: <Profile />, layout: true },
    { path: "/country-control", element: <CountryControl />, layout: true },
    { path: "/forgot-password", element: <ForgotPassword />, layout: false },
    { path: "/new-password", element: <NewPassword />, layout: false },
    { path: "/orders", element: <OrderList />, layout: true },
    { path: "/order-detail", element: <OrderDetail />, layout: true },
    { path: "/chatbot-configuration", element: <Chatconfiguration />, layout: true },
    { path: "/setting", element: <Setting />, layout: true },
    {path: "/analysis-report", element: <OrderAnalysis/>, layout: true},
    { path: "/vegetation-type", element: <VegetationType />, layout: true },
  ];

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routeList.map(({ path, element, layout }) => (
          <Route
            key={path}
            path={path}
            element={layout ? <Layout>{element}</Layout> : element}
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default Approutes;
